import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ProgressBar } from 'react-bootstrap';

class TabsTwo extends Component{
    render(){
        let 
        tab1 = "Skills",
        tab2 = "Esperienza",
        tab3 = "Educazione e certificazioni";
        const { tabStyle } = this.props
        return(
            <div>
                {/* Start Tabs Area */}
                <div className="tabs-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs>
                                    <TabList  className={`${tabStyle}`}>
                                        <Tab>{tab1}</Tab>
                                        <Tab>{tab2}</Tab>
                                        <Tab>{tab3}</Tab>
                                    </TabList>
                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <div className={`rn-progress-bar progress-bar--1 mt_dec--10`}>
                                                <div className="single-progress">
                                                    <h6 className="title">Frontend</h6>
                                                    <ProgressBar now={92} />
                                                    <span className="label">92%</span>
                                                </div>

                                                <div className="single-progress">
                                                    <h6 className="title">Backend</h6>
                                                    <ProgressBar now={84} />
                                                    <span className="label">84%</span>
                                                </div>
                                                <div className="single-progress">
                                                    <h6 className="title">Sistemi</h6>
                                                    <ProgressBar now={55} />
                                                    <span className="label">55%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                               <li>
                                                   <p>The New Ear<span> - IT Team Lead && Software Developer</span></p> Mar 2022 - Oggi
                                               </li>
                                               <li>
                                                   <p>Evvai.com<span> - Web developer</span></p> dic 2018 - Feb 2022
                                               </li>
                                               <li>
                                                   <p>TecnoEnergine Rettifiche <span> - Responsabile web</span></p> gen 2018 - mag 2018 (part-time)
                                               </li>
                                               <li>
                                                   <p>Comdata Group<span> - Operatore customer care</span></p> dic 2017 - dic 2018  
                                               </li>
                                           </ul>
                                       </div>
                                    </TabPanel>
                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                                <li>
                                                   <p>Liceo Scientifico A.Vallone <span> Galatina(LE) </span>2005 - 2010</p>
                                               </li>
                                               <li>
                                                   <p>Fondamenti di Marketing Digitale<span> - Google -  </span>  Giugno 2020  
                                                     <a href="https://learndigital.withgoogle.com/digitaltraining/validate-certificate-code">
                                                         Verifica certificato <span>( ID certificato: 6JK4S25C9 )</span></a>
                                                   </p>
                                               </li>
                                           </ul>
                                       </div>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Tabs Area */}
            </div>
        )
    }
}



export default TabsTwo;